import { useTranslation } from "../../utils/hooks/useTranslation";
import { ResolvedLibrarySummary } from "../library/sanityQuery";
import { ContactCardWrapper } from "./ContactCard";

const LibraryCard = ({ library }: { library: ResolvedLibrarySummary }) => {
  const { ts } = useTranslation();
  if (!library) {
    return null;
  }
  return (
    <ContactCardWrapper
      employeeOrLibrary={library}
      email={library.contactInfo?.email}
      phone={library.contactInfo?.phone}
      name={ts(library.name)!}
    />
  );
};

export default LibraryCard;
